export const ROLLUP = {
    ROLLUPT_KABOB_BTN: "rollup-kabob-btn",
    EXPORT_MENU_ITEM: "export-menu-item",
    EDIT_MENU_ITEM: "edit-menu-item",
    EXPORT_DIALOG_DESCRIPTION: "export-dialog-description",
    EXPORT_DIALOG_BUTTON: "export-dialog-button",
    EXPORT_ALLOCATION_DIMENSION: "export-allocation-dimension",
    SELECT_ALL: "export-select-all",
    VISIBLE: "export-visible",
    ALL_ROWS: "export-all-rows",
};
